const REGULATIONS_BASE_PATH = `${process.env.PUBLIC_URL || ""}/Markdown/Countries`;
const REGULATIONS_DEFAULT_LANGUAGE = "EN";

const REGULATIONS_LANGUAGE_MAP = {
  en: "EN",
  bg: "BG",
};

function normalizeLanguageCode(language) {
  const normalized = String(language || "")
    .trim()
    .toLowerCase()
    .split("-")[0];

  if (!normalized) {
    return REGULATIONS_DEFAULT_LANGUAGE;
  }

  return REGULATIONS_LANGUAGE_MAP[normalized] || normalized.toUpperCase();
}

function buildRegulationsIndexUrl(languageCode) {
  return `${REGULATIONS_BASE_PATH}/FishingRegulations-${languageCode}.json`;
}

function getRegulationsIndexCandidates(language) {
  const preferredLanguage = normalizeLanguageCode(language);
  const candidates = [
    buildRegulationsIndexUrl(preferredLanguage),
    buildRegulationsIndexUrl(REGULATIONS_DEFAULT_LANGUAGE),
  ];

  return [...new Set(candidates)];
}

function resolveMarkdownPathForLanguage(filePath, language) {
  const normalizedPath = String(filePath || "").trim().replace(/^\/+/, "");
  if (!normalizedPath) {
    return "";
  }

  const preferredLanguage = normalizeLanguageCode(language);
  return normalizedPath.replace(/\/(EN|BG)(?=\/)/i, `/${preferredLanguage}`);
}

function getMarkdownCandidates(filePath, language) {
  const preferredPath = resolveMarkdownPathForLanguage(filePath, language);
  const englishPath = resolveMarkdownPathForLanguage(
    filePath,
    REGULATIONS_DEFAULT_LANGUAGE
  );

  return [...new Set([preferredPath, englishPath].filter(Boolean))];
}

async function fetchJsonWithFallback(urlCandidates, options) {
  let lastError = null;

  for (const url of urlCandidates) {
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`Failed loading regulations JSON: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Failed loading regulations JSON");
}

async function fetchMarkdownWithFallback(filePath, language, options) {
  let lastError = null;

  for (const relativePath of getMarkdownCandidates(filePath, language)) {
    const url = `${REGULATIONS_BASE_PATH}/${relativePath}`;

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`Failed loading markdown: ${response.status}`);
      }

      const markdown = await response.text();
      if (markdown.trim()) {
        return markdown;
      }

      lastError = new Error(`Markdown file is empty: ${relativePath}`);
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Failed loading markdown");
}

export {
  fetchJsonWithFallback,
  fetchMarkdownWithFallback,
  getRegulationsIndexCandidates,
  normalizeLanguageCode,
};
